<template>
    <div class="section pt-2 pb-4">
        <div class="section-title mal-text" style="font-size:16px;font-weight:800;color:#1a418c;margin-bottom:10px;">
            QHLS Final Exam Qualified
        </div>

        <!-- State admin: district + zone + center filters -->
        <div v-if="user_level === 1" class="card p-2 mb-2" style="border-radius:12px;">
            <div style="display:flex;flex-direction:column;gap:8px;">
                <select v-model="district_id" class="form-select form-select-sm" @change="onDistrictChange">
                    <option value="">All Districts</option>
                    <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                </select>
                <select v-model="zone_id" class="form-select form-select-sm" @change="onZoneChange">
                    <option value="">All Zones</option>
                    <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                </select>
                <select v-model="center_id" class="form-select form-select-sm">
                    <option value="">All Centers</option>
                    <option v-for="c in centers" :key="c.id" :value="c.id">{{ c.madrasa_name }}</option>
                </select>
                <button type="button" class="btn btn-primary btn-sm" @click="loadList" style="border-radius:8px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                    <ion-icon v-else name="search-outline" class="me-1"></ion-icon>
                    Search
                </button>
            </div>
        </div>

        <!-- District admin: zone filter only -->
        <div v-else-if="user_level === 2" class="card p-2 mb-2" style="border-radius:12px;">
            <div style="display:flex;flex-direction:column;gap:8px;">
                <select v-model="zone_id" class="form-select form-select-sm" @change="onZoneChange">
                    <option value="">All Zones</option>
                    <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                </select>
                <select v-if="centers.length" v-model="center_id" class="form-select form-select-sm">
                    <option value="">All Centers</option>
                    <option v-for="c in centers" :key="c.id" :value="c.id">{{ c.madrasa_name }}</option>
                </select>
                <button type="button" class="btn btn-primary btn-sm" @click="loadList" style="border-radius:8px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                    <ion-icon v-else name="search-outline" class="me-1"></ion-icon>
                    Search
                </button>
            </div>
        </div>

        <!-- Summary -->
        <div v-if="loaded" class="card mb-2" style="border-radius:12px;padding:10px 14px;background:#f0fff6;border:1px solid #b7f0d4;">
            <div style="display:flex;align-items:center;justify-content:space-between;">
                <span style="font-size:13px;color:#1DCC70;font-weight:700;" class="mal-text">യോഗ്യരായവർ (40+ മാർക്ക്)</span>
                <span style="font-size:22px;font-weight:900;color:#1DCC70;">{{ list.length }}</span>
            </div>
        </div>

        <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary"></div>
        </div>
        <div v-else-if="loaded && !list.length" class="text-center text-muted py-4 mal-text" style="font-size:14px;">
            യോഗ്യരായ വിദ്യാർത്ഥികൾ ഇല്ല
        </div>
        <div v-else-if="list.length" style="display:flex;flex-direction:column;gap:8px;">
            <div v-for="(item, idx) in list" :key="item.registration_id"
                style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;display:flex;align-items:center;gap:12px;">
                <div style="width:32px;height:32px;border-radius:50%;background:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                    <span style="color:#fff;font-size:12px;font-weight:800;">{{ idx + 1 }}</span>
                </div>
                <div style="flex:1;min-width:0;">
                    <div style="font-size:15px;font-weight:800;color:#1e293b;">{{ item.name }}</div>
                    <div style="font-size:12px;color:#64748b;margin-top:2px;">
                        {{ item.center_name || '—' }}
                        <span v-if="item.zone_name"> · {{ item.zone_name }}</span>
                        <span v-if="item.district_name && user_level === 1"> · {{ item.district_name }}</span>
                    </div>
                </div>
                <div style="flex-shrink:0;text-align:center;">
                    <div style="font-size:20px;font-weight:900;color:#1DCC70;line-height:1;">{{ item.effective_mark }}</div>
                    <div style="font-size:10px;color:#94a3b8;font-weight:600;">മാർക്ക്</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../services/user.service';

export default {
    name: 'QhlsFinalQualified',
    data() {
        return {
            user_level: 1,
            district_id: '',
            zone_id: '',
            center_id: '',
            districts: [],
            zones: [],
            centers: [],
            list: [],
            loading: false,
            loaded: false,
        };
    },
    mounted() {
        this.$store.dispatch('setPageHeader', 'QHLS Final Exam Qualified');
        const currentUser = this.$store.getters.currentUser;
        this.user_level = parseInt((currentUser && currentUser.user_level) || 1);
        if (this.user_level === 1) {
            this.loadDistricts();
        } else if (this.user_level === 2) {
            // District admin: load their zones and auto-show list
            this.loadZones();
            this.loadList();
        } else {
            // Zone/unit admin: auto-load immediately
            this.loadList();
        }
    },
    methods: {
        loadDistricts() {
            UserService.authGetRequest('get-districts').then(r => {
                if (r.data.status === 'success') this.districts = r.data.data.list || r.data.data || [];
            });
        },
        onDistrictChange() {
            this.zone_id = ''; this.center_id = ''; this.zones = []; this.centers = [];
            if (this.district_id) this.loadZones();
        },
        loadZones() {
            const params = this.district_id ? { district_id: this.district_id } : {};
            UserService.authGetRequest('get-zones', params).then(r => {
                if (r.data.status === 'success') this.zones = r.data.data.list || r.data.data || [];
            });
        },
        onZoneChange() {
            this.center_id = ''; this.centers = [];
            if (this.zone_id) this.loadCenters();
        },
        loadCenters() {
            const params = {};
            if (this.zone_id) params.zone_id = this.zone_id;
            else if (this.district_id) params.district_id = this.district_id;
            UserService.authGetRequest('get-qhls-centers', params).then(r => {
                if (r.data.status === 'success') this.centers = r.data.data.list || r.data.data || [];
            });
        },
        loadList() {
            this.loading = true;
            this.loaded = false;
            UserService.authPostRequest('get-qhls-final-qualified-list', {
                district_id: this.district_id || null,
                zone_id:     this.zone_id     || null,
                center_id:   this.center_id   || null,
            }).then(r => {
                this.loading = false;
                this.loaded = true;
                this.list = r.data.status === 'success' ? (r.data.data.list || []) : [];
            }).catch(() => { this.loading = false; this.loaded = true; this.list = []; });
        },
    },
};
</script>
